export class OnboardVrifications{
    Id:number;
    EmpId:number;
  SectionId: string;
  Name: string;
  EmpName: string;
    Status:boolean;
    VerifiedBy:number;
    VerifiedDate:Date
}
